import React, { useMemo } from 'react';
import classNames from 'classnames';
import { DataRoomRFICategory } from 'router/subrouters/DataRoom/models/DataRoomRfi';
import ReorderResizeTable from 'components/ReorderResizeTable';
import {
  TABLE_COLUMNS,
  HEADING_TRANSLATIONS,
  SORTING_VALUES,
  CUSTOM_COL_SIZES,
  BODY_CONTENT_GENERATE,
  RfiChecklistCategoryTableRow,
} from './data';

type RfiChecklistCategoriesTableProps = {
  className?: string;
  isLoading?: boolean;
  data: DataRoomRFICategory[];
  totalPages?: number;
  totalItems?: number;
  onRowClick: (category: DataRoomRFICategory) => void;
};

const RfiChecklistCategoriesTable: React.FC<
  RfiChecklistCategoriesTableProps
> = (props) => {
  const { className, isLoading, data, totalPages, totalItems, onRowClick } =
    props;

  const classes = classNames('rfi-checklist-categories-table', className);

  const tableContentTransformations = useMemo(
    () =>
      TABLE_COLUMNS.reduce(
        (acc, col) => ({
          ...acc,
          [col]: (category: DataRoomRFICategory) =>
            BODY_CONTENT_GENERATE[col]({ category }),
        }),
        {},
      ),
    [],
  );

  return (
    <ReorderResizeTable
      className={classes}
      isDragDisabled
      isResizeDisabled
      isDataLoading={isLoading}
      columns={TABLE_COLUMNS}
      data={data as unknown as RfiChecklistCategoryTableRow[]}
      headingTranslations={HEADING_TRANSLATIONS}
      tableContentTransformations={tableContentTransformations}
      sortingValues={SORTING_VALUES}
      customSizes={CUSTOM_COL_SIZES}
      totalPages={totalPages}
      totalItems={totalItems}
      onRowClick={(row) => onRowClick(row as unknown as DataRoomRFICategory)}
    />
  );
};

export default RfiChecklistCategoriesTable;
